import { isCanonicalCountryCode } from '@shared/utils/country';

export interface ProfileCompletionInput {
  firstName?: string | null;
  lastName?: string | null;
  gender?: string | null;
  birthday?: string | Date | null;
  country?: string | null;
  city?: string | null;
  location?: { country?: string | null; city?: string | null } | null;
}

const firstFilled = (...values: (string | null | undefined)[]): string =>
  values.find(
    (value) => value !== null && value !== undefined && value !== '',
  ) ?? '';

export const isProfileComplete = (user: ProfileCompletionInput): boolean =>
  Boolean(
    user.firstName &&
    user.firstName.trim() !== '' &&
    user.lastName &&
    user.lastName.trim() !== '' &&
    user.gender &&
    user.gender !== 'UNDEFINED' &&
    user.birthday &&
    isCanonicalCountryCode(firstFilled(user.location?.country, user.country)) &&
    firstFilled(user.location?.city, user.city) !== '' &&
    user.location?.city !== 'Unknown',
  );

export const requiresProfileCompletion = (
  user: ProfileCompletionInput | null | undefined,
  isDelegatedIdentity: boolean,
): boolean => {
  if (!user) return false;
  if (isDelegatedIdentity) return false;
  return !isProfileComplete(user);
};
